import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const HolidayFormModal = ({ 
  show, 
  onHide, 
  mode, 
  formData, 
  setFormData, 
  onSubmit, 
}) => {
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header>
        <Modal.Title>{mode === 'edit' ? 'Edit Holiday' : 'Add New Holiday'}</Modal.Title>
        <button onClick={onHide} className="modal-close">
          <i className="bi bi-x-lg fs-5"></i>
        </button>
      </Modal.Header>
      
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Holiday Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={formData.name || ''}
              onChange={handleChange}
              placeholder="e.g., Diwali"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Date</Form.Label>
            <Form.Control
              type="date"
              name="date"
              value={formData.date || ''}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Holiday Type</Form.Label>
            <Form.Select 
              name="type" 
              value={formData.type || ''} 
              onChange={handleChange}
            >
              <option value="">Select Type</option>
              <option value="National">National / Mandatory</option>
              <option value="Festival">Festival</option>
              <option value="Regional">Regional</option>
              <option value="Restricted">Restricted / Floating</option>
            </Form.Select>
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="cancel-cta" onClick={onHide}>
          Close
        </Button>
        <Button
          variant="update-cta"
          onClick={onSubmit}
        >
          {mode === 'edit' ? 'Update Holiday' : 'Save Holiday'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default HolidayFormModal;